import React from 'react';
import { Link } from 'react-router-dom';
import pawImg from '../assets/paw.png';
import { ReactComponent as DogIcon } from '../assets/icons/dog.svg';
import { ReactComponent as ForkKnifeIcon } from '../assets/icons/fork-knife.svg';
import { ReactComponent as ChartBarIcon } from '../assets/icons/chart-bar.svg';
import './tips.css';

const tips = [
    {
        title: 'Creative Mixing Containers',
        text: 'If you don’t have big kitchen bowls, get creative! Use clean moving bins or any large container around the house, as long as it’s clean and the food has cooled off.',
        img: require('../assets/maggie-looking-at-food-cont.jpg')
    },
    {
        title: 'Shred Meat Quickly',
        text: 'Shred chicken or other meat with a hand-held blender, it makes the process much faster.',
        img: require('../assets/blending-chicken.jpg')
    },
    {
        title: 'Blend for Picky Dogs',
        text: 'If your dog picks out certain ingredients, blend everything together with a hand-held blender for a uniform meal.',
        img: require('../assets/blending-veggies.jpg')
    },
    {
        title: 'Dog Cleanup Crew', 
        text: 'Dogs love to help with cleanup, let them lick the bin or bowl “clean” at the end. It’s fun for them and helps you too!',
        img: require('../assets/maggie-cleaning-bowl.jpg')
    },
    {
        title: 'Cook Everything at Once',
        text: 'If you don’t have much time, cook everything at once, use the oven and stove together. If the rice or something gets a little soggy, the dogs won’t mind. It doesn’t have to be perfectly cooked as long as it’s cooked all the way.',
        img: require('../assets/cook-all-at-once.jpg')
    },
    {
        title: 'Use Ingredients Going Bad',
        text: 'If you have food in your house that’s going bad (like apples or veggies you don’t want to eat), use them in your dog’s food as long as they’re safe for dogs and not spoiled. PS: apple seeds are toxic to dogs, so be sure to core them out before feeding!',
        img: require('../assets/use-stuff-going-bad.jpg')
    },
    {
        title: 'Batch Cooking',
        text: 'Prepare several meals at once and freeze portions for convenience.',
        img: require('../assets/batch-cooking.JPG')
    },
    {
        title: 'Mix Well',
        text: 'Mix supplements and oils thoroughly into the food before serving.',
        img: require('../assets/me-mixing-food.jpg')
    },
    {
        title: 'Safe Storage',
        text: 'Store cooked food in airtight containers in the fridge for up to 4 days, or freeze for longer.',
        img: require('../assets/safe-storage.jpg')
    },
    {
        title: 'Label Meals',
        text: 'Label containers with the date and recipe to keep track of freshness.',
        img: require('../assets/storage.jpg')
    },
    {
        title: 'Thawing',
        text: 'Thaw frozen meals in the fridge overnight, never at room temperature.',
        img: require('../assets/patient-maggie.PNG')
    },
];

const Tips: React.FC = () => (
  <div className="page-container cream-bg">
    {/* Floating Paw Print Background */}
    <div className="hero-paw-bg">
      <img src={pawImg} className="hero-paw-float paw1" alt="" />
      <img src={pawImg} className="hero-paw-float paw2" alt="" />
      <img src={pawImg} className="hero-paw-float paw3" alt="" />
      <img src={pawImg} className="hero-paw-float paw4" alt="" />
      <img src={pawImg} className="hero-paw-float paw5" alt="" />
      <img src={pawImg} className="hero-paw-float paw6" alt="" />
      <img src={pawImg} className="hero-paw-float paw7" alt="" />
    </div>
    <div className="page-intro">
      <h1 className="page-title">Homemade Dog Food Guides & Tips</h1>
      <div className="page-intro-underline" />
      <p className="page-intro-desc">Helpful guides and practical tips for preparing, storing, and feeding homemade dog food safely.</p>
    </div>

    {/* Feeding Guides Section */}
    <div className="guides-section">
      <h2 className="guides-title">Feeding Guides</h2>
      <div className="guides-grid">
        <Link to="/transition-guide" className="guide-card">
          <DogIcon className="guide-icon" />
          <h3>Transition Guide</h3>
          <p>Safely transition your dog to homemade food over 7–10 days with our step-by-step schedule.</p>
          <span className="guide-arrow">→</span>
        </Link>
        <Link to="/feeding-portions" className="guide-card">
          <ForkKnifeIcon className="guide-icon" />
          <h3>How Much Homemade Food to Feed</h3>
          <p>Understand portion sizes based on your dog's weight, age, and body condition.</p>
          <span className="guide-arrow">→</span>
        </Link>
        <Link to="/how-recipes-are-developed" className="guide-card">
          <ChartBarIcon className="guide-icon" />
          <h3>How Recipes Are Developed</h3>
          <p>Discover the nutritional principles and science behind our balanced homemade dog food recipes.</p>
          <span className="guide-arrow">→</span>
        </Link>
          <Link to="/homemade-dog-food-for-allergies" className="guide-card">
            <span className="guide-icon" role="img" aria-label="allergy">🌾</span>
            <h3>Homemade Dog Food for Allergies</h3>
            <p>Learn about food allergies, novel proteins, and find allergy-friendly homemade recipes for sensitive dogs.</p>
            <span className="guide-arrow">→</span>
          </Link>
      </div>
    </div>

    <h2 className="guides-title">Kitchen Tips</h2>
    <div className="tips-content tips-grid">
      {(() => {
        const left = tips.filter((_, i) => i % 2 === 0);
        const right = tips.filter((_, i) => i % 2 === 1);
        return (
          <>
            <div className="tips-col">
              {left.map((tip, i) => (
                <div className="tip-card" key={tip.title + '-left'}>
                  <h3>{tip.title}</h3>
                  <p>{tip.text}</p>
                  {tip.img && (
                    <img src={tip.img} alt={tip.title} className="tip-image" />
                  )}
                </div>
              ))}
            </div>
            <div className="tips-col">
              {right.map((tip, i) => (
                <div className="tip-card" key={tip.title + '-right'}>
                  <h3>{tip.title}</h3>
                  <p>{tip.text}</p>
                  {tip.img && (
                    <img src={tip.img} alt={tip.title} className="tip-image" />
                  )}
                </div>
              ))}
            </div>
          </>
        );
      })()}
    </div>
  </div>
);

export default Tips;
